import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MDSnackbar from "components/MDSnackbar";
import { useState } from "react";
import appData from "layouts/mosques/data/appData";
import { useAddMosque } from "api/useMosques.ts";
import MDBox from "components/MDBox";
import { useMediaQuery, useTheme } from "@mui/material";

function Tables() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const addMosque = useAddMosque();
  const [isMosqueModalOpen, setIsMosqueModalOpen] = useState(false);
  const [newMosque, setNewMosque] = useState({
    name: "",
    address: "",
    location: {
      type: "",
      coordinates: [],
    },
  });

  const { columns, rows, notification, setNotification, handleCloseNotification } = appData();

  const handleAddMosqueClick = () => {
    setIsMosqueModalOpen(true); // Open modal for adding new mosque
  };
  const handleCloseAddMosqueModal = () => {
    setIsMosqueModalOpen(false); // Close modal
    setNewMosque({
      name: "",
      address: "",
      location: {
        type: "",
        coordinates: [],
      },
    });
  };
  const handleInputChangeNewMosque = (e) => {
    const { name, value } = e.target;

    setNewMosque((prevState) => {
      if (name === "x" || name === "y") {
        const newCoordinates = [...prevState.location.coordinates];
        if (name === "x") {
          newCoordinates[1] = parseFloat(value) || ""; // Latitude at index 1
        } else {
          newCoordinates[0] = parseFloat(value) || ""; // Longitude at index 0
        }

        return {
          ...prevState,
          location: {
            ...prevState.location,
            coordinates: newCoordinates,
          },
        };
      } else if (name.includes(".")) {
        // Handle nested properties like location.type
        const [parentKey, childKey] = name.split(".");
        return {
          ...prevState,
          [parentKey]: {
            ...prevState[parentKey],
            [childKey]: value,
          },
        };
      } else {
        // Handle non-nested fields like name, address
        return {
          ...prevState,
          [name]: value,
        };
      }
    });
  };

  const handleSaveMosque = async () => {
    const mosqueData = {
      name: newMosque.name,
      address: newMosque.address,
      location: {
        type: newMosque.location.type,
        coordinates: newMosque.location.coordinates,
      },
    };

    addMosque.mutate(mosqueData, {
      onSuccess: () => {
        setNotification({
          open: true,
          message: "Mosque added successfully",
          severity: "success",
        });
        handleCloseAddMosqueModal(); // Close modal on success
      },
      onError: (error) => {
        console.error("Error adding mosque:", error);
        setNotification({
          open: true,
          message: "Failed to add mosque. Please try again.",
          severity: "error",
        });
      },
    });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="dark"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                justifyContent="space-between"
                alignItems={isMobile ? "flex-start" : "center"}
              >
                <MDTypography variant="h6" color="white">
                  Mosques Table
                </MDTypography>
                <MDBox
                  display="flex"
                  flexDirection={isMobile ? "column" : "row"}
                  gap={isMobile ? 2 : "10px"}
                  width={isMobile ? "100%" : "auto"}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleAddMosqueClick}
                    fullWidth={isMobile}
                    sx={{
                      borderRadius: 2,
                      fontSize: 14,
                      padding: "8px 16px",
                      color: "black",
                    }}
                  >
                    Add Mosque
                  </Button>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={false}
                  showTotalEntries
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      {/* Mosque Modal */}
      <Dialog open={isMosqueModalOpen} onClose={handleCloseAddMosqueModal}>
        <DialogTitle>Add New Mosque</DialogTitle>
        <DialogContent>
          <TextField
            name="name"
            label="Mosque Name"
            value={newMosque.name || ""}
            onChange={handleInputChangeNewMosque}
            fullWidth
            margin="dense"
          />
          <TextField
            name="address"
            label="Mosque Address"
            value={newMosque.address || ""}
            onChange={handleInputChangeNewMosque}
            fullWidth
            margin="dense"
          />
          <TextField
            name="location.type"
            label="Location Type"
            value={newMosque.location?.type || ""}
            onChange={handleInputChangeNewMosque}
            fullWidth
            margin="dense"
          />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                name="x"
                label="Latitude (X)"
                type="number"
                value={newMosque.location?.coordinates[1] || ""} // Ensure index 1 for latitude
                onChange={handleInputChangeNewMosque}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="y"
                label="Longitude (Y)"
                type="number"
                value={newMosque.location?.coordinates[0] || ""} // Ensure index 0 for longitude
                onChange={handleInputChangeNewMosque}
                fullWidth
                margin="dense"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAddMosqueModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveMosque} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* Notification Snackbar */}
      <MDSnackbar
        color={notification.severity}
        icon={notification.severity === "success" ? "check" : "error"}
        title={notification.severity === "success" ? "Success" : "Error"}
        content={notification.message}
        open={notification.open}
        onClose={handleCloseNotification}
        close={handleCloseNotification}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default Tables;
